module.exports = __webpack_public_path__ + "entry-150bfe9b/Background_01_4x3_a-5e6a278316b3503dc2410507a3b4a7a4.svg";